module.exports = __webpack_public_path__ + "img/renlianji.fdb7e5ff.png";